<template>
    <p>
        {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        <br />
        {{ userStore.user.address }}
        <br />
        {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
    </p>
    <p>
        {{ creditor.creditor_name }}
        <br />
        <template v-if="creditor.address">
            {{ creditor.address }}
        </template>
        <template v-else>
            {{ creditor.address_line }}<br /> {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
        </template>
    </p>
    <p>
        {{ date }}
    </p>
    <p style="text-align: center;">
        NOTICE TO PRINCIPAL IS NOTICE TO AGENT NOTICE TO AGENT IS NOTICE TO PRINCIPAL
    </p>
    <p>
        To Whom It May Concern:
    </p>
    <p class="letter-content">
        I recently received a copy of my (Experian, Equifax or TransUnion) consumer report, and I noticed some late payments posted on my consumer report:
    </p>
    <p v-for="(account, iteration) in accounts">
        <strong>
            {{ account.furnisher_name }} with account number {{ account.account_number }}
        </strong>
        <template v-if="account.reason">
            <br />
            {{ account.reason }}
        </template>
    </p>
    <p class="letter-content">
        Your company is in clear violation of the law. Pursuant 15 USC §1681a 2(A)(i) 
    </p>
    <p class="letter-content">
        - EXCLUSIONS- Except as provided in paragraph (3), the term “consumer report” does not include—
    </p>
    <p class="letter-content">
        (A)subject to section 1681s-3 of this title, any—
    </p>
    <p class="letter-content">
        (i)
        <br />
        report containing information solely as to transactions or experiences between the consumer and the person making the report;
    </p>
    <p class="letter-content">
        THE LAW CLEARLY STATES:
    </p>
    <p class="letter-content">
        Transactions between the consumer {{ userStore.user.firstname }} {{ userStore.user.lastname }} and the person {{ creditor.creditor_name }} Making the report is not INCLUEDED on my Consumer report!
    </p>
    <p class="letter-content">
        A Late payment is a transactional history, My HISTORY with your company. CONGRESS clearly states that the reporting of Transactions or experiences between the CONSUMER and the PERSON making the report is not included on the consumer reports!
    </p>
    <p class="letter-content">
        YOU HAVE VIOLATED THE FCRA 15USC 1681a 2Ai by reporting this transaction or experience on my consumer which CONGRESS clearly states IS NOT included on my CONSUMER REPORTS.
    </p>
    <p class="letter-content">
        You have 10 calendar days to update my Payment history and or delete all late payments from the below account/s
    </p>
    <p v-for="(account, iteration) in accounts">
        <strong>
            {{ account.furnisher_name }} with account number {{ account.account_number }}
        </strong>
        <template v-if="account.reason">
            <br />
            {{ account.reason }}
        </template>
    </p>
    <p class="letter-content">
        Failure to respond satisfactorily with deletion of the above Late Payments, will result in legal actions being taken against your company, for which I will also be seeking $ 1,000 per violation for:
    </p>
    <ol>
        <li>
            Defamation of Character
        </li>
        <li>
            Negligent Non Compliance
        </li>
        <li>
            Civil Liability
        </li>
        <li>
            Mental Anguish 
        </li>
        <li>
            Fair Credit Reporting Act 15USC §1681 violations for willful noncompliance - §616. Civil liability for willful noncompliance [15 U.S.C. §1681n] 
        </li>
    </ol>
    <p>
        Best regards,
        <br />
        {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        <br />
    </p>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                reportStore: useReportStore(),
                lodash: lodash
            };
        }
    };
</script>
